module.exports = __webpack_public_path__ + "media/images/lp/1/tamai-pc-29c7fae16ca13b9b6395c9a1a1b91bec.jpg";